import { Marker } from "react-leaflet";
import L from "leaflet";

/* Non-interactive pulsating red marker used to highlight a NAP the user
 * navigated to from a Job Order / Migration detail modal. */
const PULSE_ICON = L.divIcon({
  className: "", // avoid default leaflet-div-icon white box
  html: '<div class="nap-pulse-marker"></div>',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
});

export default function NapPulseMarker({ position }) {
  if (!position || position[0] == null || position[1] == null) return null;
  return (
    <Marker position={position} icon={PULSE_ICON} interactive={false} zIndexOffset={2000} />
  );
}
